'use strict';

import { module } from '../app';

module.service('Document', [
  '$http', 'authService', function ($http, authService) {
    return {
      getAllBySsn: function (ssn) {
        return $http.post(`${authService.currentMagViewUrl()}/api/techpadDocuments/loadDocuments`, { ssn });
      },
      getRadReportBySsnAndSDate: function (ssn, sdate) {
        return $http.get(`${authService.currentMagViewUrl()}/api/techpadDocuments/GetRadReportBySsnAndSDate?ssn=${ssn}&sdate=${sdate}`);
      },
      saveImportDocuments: function (model) {
        const url = `${authService.currentMagViewUrl()}/api/techpadDocuments/saveImportDocuments`;
        const request = new FormData();
        const keys = Object.keys(model);
        for (const key of keys) {
          request.append(key, model[key]);
        }

        return $http({
            url: url,
            headers: {"Content-Type": undefined },
            data: request,
            method: "POST"
        });
      },
      deleteDocument: function (ssn, id) {
        return $http.post(`${authService.currentMagViewUrl()}/api/techpadDocuments/deleteDocument`, { ssn, id });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/document.js